import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4cdd468"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OptinV2",
  "aria-label": "Email preferences",
  "data-cy": "OptIn",
  ref: "root"
}
const _hoisted_2 = { class: "Content" }
const _hoisted_3 = { class: "Footer" }
const _hoisted_4 = {
  key: 0,
  class: "ErrorMessage"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Unsubscribe" }, [
  /*#__PURE__*/_createTextVNode("Free "),
  /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "•"),
  /*#__PURE__*/_createTextVNode(" Unsubscribe anytime")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, {
    to: _ctx.modalContainer,
    disabled: _ctx.store.getters.isModal()
  }, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "content", {}, undefined, true)
      ]),
      _createElementVNode("footer", _hoisted_3, [
        (_ctx.store.getters.errorMessage().message)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.store.getters.errorMessage().message), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _hoisted_5,
        _createElementVNode("button", {
          class: "EmailUpdatesBtn",
          "data-cy": "AcceptOptIn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args)))
        }, "Get email updates"),
        _createElementVNode("button", {
          class: "DenyOptin",
          "data-cy": "DeclineOptIn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deny && _ctx.deny(...args)))
        }, "Not now")
      ])
    ], 512 /* NEED_PATCH */)
  ], 8 /* PROPS */, ["to", "disabled"]))
}